exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".guest_entry_btn[data-v-4c24cf76]{box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);background:linear-gradient(90deg,#b22c27,#e83029);bottom:calc(env(safe-area-inset-bottom) + 70px);z-index:100}", ""]);
